export default "__VITE_ASSET__Ch7OtE9O__"